import Axios from 'axios';
import { Message } from 'element-ui';
const axios = Axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 10000,
});

let Http = function (options, method = 'get') {
  // do something
  method = options.method || method;
  const obj = {
    Authorization: localStorage.getItem('clock_in_token'),
  };
  let load = {};
  if (method === 'post') {
    Object.assign(load, {
      data: options.params,
    });
  } else if (method === 'get') {
    Object.assign(load, {
      params: options.params,
    });
  } else if (method === 'delete') {
    Object.assign(load, {
      params: options.params,
    });
  }
  return axios({
    method,
    headers: options.headers ? Object.assign(obj, options.headers) : obj,
    url: options.url,
    ...load,
    responseType: options.responseType ? options.responseType : 'json',
  })
    .then((res) => {
      if (options?.['responseType']) {
        // 处理文件导出
        if (res.status / 1 === 200) {
          options.success && options.success(res);
        } else {
          options.fail && options.fail(res);
          Message.error(res.statusText);
        }
      } else {
        if (res.data.code === 200) {
          options.success && options.success(res.data);
        } else {
          options.fail && options.fail(res.data);
          if (res.data.code === 10001 || res.data.code === 401) {
            localStorage.removeItem('clock_in_token');
            window.$vue.$router.replace({ path: '/login' });
          }
          Message.error(res.data.msg);
        }
      }
    })
    .catch((res) => {
      options.fail && options.fail(res.response?.data);
      Message.error({
        message: res.message,
      });
    })
    .finally((res) => {
      options.complete && options.complete(res);
    });
};
Http.get = function (options) {
  return Http(options, 'get');
};

Http.post = function (options) {
  return Http(options, 'post');
};

Http.delete = function (options) {
  return Http(options, 'delete');
};

export default Http;
